import { Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Mapa } from 'src/app/models/mapa-models/mapa.model';
import { Fila } from 'src/app/models/mapa-models/fila-mapas.model';
import { LocalidadMapa } from 'src/app/models/mapa-models/localidadmapa.model';
import { Ticket } from 'src/app/models/ticket.model';
import { Seccion } from 'src/app/models/mapa-models/seccion.model';
import { SeccionInclinada } from 'src/app/models/mapa-models/seccion-inclinada.model';
import { SeccionPlana } from 'src/app/models/mapa-models/seccion-plana.model';
import { MapaDataService } from 'src/app/service/data/mapa-data.service.service';
import { Informativo } from 'src/app/models/mapa-models/informativo-mapas.model';
import { MatDialog } from '@angular/material/dialog';
import { ClientePagos } from 'src/app/models/cliente-pagos.model';
import { CantidadBoletasComponent } from '../cantidad-boletas/cantidad-boletas.component';
import { HardcodedAutheticationService } from 'src/app/service/hardcoded-authetication.service';
import { Localidad } from 'src/app/models/localidad.model';
import { OrdenDataService } from 'src/app/service/data/orden-data.service';
import { ClientesPagoDataService } from 'src/app/service/data/clientes-pago-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TicketDataService } from 'src/app/service/data/ticket-data.service';
import { Arco,ArcoRadio, Forma } from 'src/app/models/mapa-models/forma.model';
import { LocalidadSeleccionComponent } from '../localidad-seleccion/localidad-seleccion.component';

@Component({
    selector: 'app-mapa',
    templateUrl: './mapa.component.html',
    styleUrls: ['./mapa.component.css'],
    standalone: false
})
export class MapaComponent implements OnInit {

  @Input() eventoId: number;
  @Input() mapaId: number;
  @Input() localidades: Localidad[];
  @Input() cliente: ClientePagos;
  @Input() mensaje: (mensaje: string) => void;
  @Input() modalLogin: () => void;



  mapa: Mapa;
  zoomFactor = 1;
  maxZoom = 4;
  minZoom = 0.3;
  altoMapa:number;
  altoInicial: number;
  anchoInicial: number;
  usuario: string;
  ticketsSeleccionados: Ticket[] = [];
  valorTotal: number = 0;
  cantidadTotal: number = 0;
  codigoVenta
  tooltipVisible = false;
  cargando:boolean;
  anchoPantalla:number
  mostrarInstrucciones: boolean;

  tooltip: HTMLElement;

  //Variable para enviar localidad seleccionada a componente CantidadBoletas para compra de tickets no numerados desde mapas
  localidad: Localidad;

  validacionTicket: Ticket; //Variable auxiliar para validar estado del ticket en base de datos


  //Mapa draggable
  private isDragging = false;
  private startX = 0;
  private startY = 0;
  private scrollLeft = 0;
  private scrollTop = 0;

  constructor(protected service: MapaDataService,
    public dialog: MatDialog,
    private ordenService: OrdenDataService,
    private clienteDataService: ClientesPagoDataService,
    private ticketService: TicketDataService,
    private mapaService: MapaDataService,
    private autenticador: HardcodedAutheticationService,
    private router: Router,
    private renderer: Renderer2, private el: ElementRef,
    private route: ActivatedRoute,


  ) { 
    this.anchoPantalla = window.innerWidth;
  };

  ngOnInit(): void {
    this.mostrarInstrucciones=true;
    this.cargando=true;
    this.cargarMapa();
    this.tooltip = this.renderer.createElement('div');
      this.renderer.addClass(this.tooltip, 'hover-info');
      this.renderer.appendChild(document.body, this.tooltip);
    this.route.paramMap.subscribe(params => {

      this.codigoVenta = params.get('codigoVenta')
      
    })


  }

  cargarMapa() {
    this.service.getPorId(this.mapaId).subscribe({
      next: (mapa) => {
        this.mapa = mapa;
        console.log(mapa)
        this.ajustarZoom()
        this.getAltoDinamicoMapa()
        this.cargando=false;
      },
      error: (error) => {console.error('Error cargando mapa:', error)
        this.cargando=false;
      }
    });
  }

  ajustarZoom(): void{
    const zoom = (this.anchoPantalla)/(this.mapa.ancho);
    this.getAltoDinamicoMapa()
    if(zoom>=1){
      this.zoomFactor=1
    }
    else{
      this.zoomFactor=zoom
    }
  }

  getAltoDinamicoMapa(): number{
    const min = 200;

    if(this.anchoPantalla>850){

      this.altoMapa=this.mapa.alto;

      return this.mapa.alto;
    }
    else{
      const altura= this.mapa.alto*this.zoomFactor;

      if(altura>=min){
        if(altura>600){
          this.altoMapa=600;

          return 600;}

        else{
          this.altoMapa=altura;

          return altura;}
      }
      else{
        this.altoMapa=min;

        return min;
      }
    }
  }

  //-------------------------------------------------
  //#region Funciones para Obtener los estilos del mapa cargado

  getTextoTicket(ticket: Ticket): string {
    if (ticket.tipo === 1) {
      if (ticket.asientosDisponibles > 0) {
        return ticket.numero_dentro_de_evento;
      } 
      else{
        switch(ticket.estado){
          case 1: return 'V';
        case 2:
          return 'V';
        case 3:
          return 'P';
        case 4:
            return 'V';
        default:
          return '';
        }
      }
    } else {
      switch (ticket.estado) {
        case 0:
          return ticket.numero_dentro_de_evento;
        case 1: return 'V';
  
        case 2:
          return 'V';
        case 3:
          return 'P';
        case 4:
            return 'V';
        default:
          return '';
      }
    }
  }
  
  ocultarInstrucciones() {
    this.mostrarInstrucciones = false;
}

  getMapaStyles() {
    return {
      'height.px': this.altoMapa,
      'width.px': this.mapa?.ancho,
      'transform': `scale(${this.zoomFactor})`,
      transformOrigin: 'top left',
    };
  }


  

  getSeccionStyles(seccion: Seccion) {
    const baseStyles = {
      transform: `rotate(${seccion.rotacion}deg)`,
    };

    if (seccion.tipo === 'plana') {
      const seccionPlana = seccion as SeccionPlana;
      return {
        ...baseStyles,
        marginTop: `${seccionPlana.margen_t}px`,
        marginBottom: `${seccionPlana.margen_b}px`,
        marginLeft: `${seccionPlana.margen_l}px`,
        marginRight: `${seccionPlana.margen_r}px`,
        clear: seccionPlana.salto ? 'both' : 'none'
      };
    } else {
      const seccionInclinada = seccion as SeccionInclinada;
      return {
        ...baseStyles,
        position: 'absolute',
        left: `${seccionInclinada.pleft}%`,
        top: `${seccionInclinada.ptop}%`,

      };
    }
  }

  getInformativoStyles(informativo: Informativo) {
    const baseStyles: any = {
      width: `${informativo.forma.ancho}px`,         // Ancho de la informativo (por defecto)
      height: `${informativo.forma.alto}px`,         // Alto de la informativo
      color: informativo.forma.color_de_texto,    // Color del texto
      lineHeight: `${informativo.forma.alto}px`,
      fontSize: `${informativo.forma.font_size}px`,  // Tamaño de la fuente
      marginTop: `${informativo.forma.margen_t}px`,  // Margen superior
      marginBottom: `${informativo.forma.margen_b}px`, // Margen inferior
      marginLeft: `${informativo.forma.margen_l}px`, // Margen izquierdo
      marginRight: `${informativo.forma.margen_r}px`, // Margen derecho
      clear: informativo.forma.salto ? 'both' : 'none', // Saltar o no
      backgroundColor: informativo.forma.color,      // Color de fondo por defecto
      borderColor: informativo.forma.color_de_borde ?? 'transparent', // Color del borde
      borderWidth: '1px',                          // Ancho del borde
      borderStyle: 'solid',                        // Estilo del borde
      borderRadius: `${informativo.forma.redondeado}px`, // Redondeado
      transform: `rotate(${informativo.forma.rotacion}deg)`, // Rotación
    };
  
    // Verificar si informativo.forma es de tipo 'Arco'
    if (informativo.forma.type === 'arco' && 'anchoArco' in informativo.forma) {
      baseStyles.width = `${(informativo.forma as Arco).anchoArco}px`;   // Ancho para el arco
      baseStyles.borderColor = 'transparent';                     // Borde negro para el arco
      baseStyles.backgroundColor = 'transparent';           // Fondo transparente para el arco
      baseStyles.cursor = 'default';
    }

    if (informativo.forma.type === 'arco-r') {
      const forma = informativo.forma as ArcoRadio;
      
      baseStyles.borderTopLeftRadius = `${forma.radioSuperiorIzquierdo}px`;
      baseStyles.borderTopRightRadius = `${forma.radioSuperiorDerecho}px`;
      baseStyles.borderBottomLeftRadius = `${forma.radioInferiorIzquierdo}px`;
      baseStyles.borderBottomRightRadius = `${forma.radioInferiorDerecho}px`;
    }

    if (informativo.forma.rotacion !=null && informativo.forma.rotacion !=0) {
      baseStyles.position = 'absolute';
    }
  
    return baseStyles;
  }

  getLocalidadStyles(localidad: LocalidadMapa) {
    const baseStyles: any = {
      width: `${localidad.forma.ancho}px`,         // Ancho de la localidad (por defecto)
      height: `${localidad.forma.alto}px`,         // Alto de la localidad
      color: localidad.forma.color_de_texto,    // Color del texto
      lineHeight: `${localidad.forma.alto}px`,
      fontSize: `${localidad.forma.font_size}px`,  // Tamaño de la fuente
      marginTop: `${localidad.forma.margen_t}px`,  // Margen superior
      marginBottom: `${localidad.forma.margen_b}px`, // Margen inferior
      marginLeft: `${localidad.forma.margen_l}px`, // Margen izquierdo
      marginRight: `${localidad.forma.margen_r}px`, // Margen derecho
      clear: localidad.forma.salto ? 'both' : 'none', // Saltar o no
      backgroundColor: localidad.forma.color,      // Color de fondo por defecto
      borderColor: localidad.forma.color_de_borde ?? 'transparent', // Color del borde
      borderWidth: '1px',                          // Ancho del borde
      borderStyle: 'solid',                        // Estilo del borde
      borderRadius: `${localidad.forma.redondeado}px`, // Redondeado
      transform: `rotate(${localidad.forma.rotacion}deg)`, // Rotación
    };

    if (localidad.forma.rotacion !=null && localidad.forma.rotacion !=0) {
      baseStyles.position = 'absolute';
    }
  
    // Verificar si localidad.forma es de tipo 'Arco'
    if (localidad.forma.type === 'arco' && 'anchoArco' in localidad.forma) {
      baseStyles.width = `${(localidad.forma as Arco).anchoArco}px`;   // Ancho para el arco
      baseStyles.borderColor = 'transparent';                     // Borde negro para el arco
      baseStyles.backgroundColor = 'transparent';           // Fondo transparente para el arco
      baseStyles.cursor = 'default';
    }

    if (localidad.forma.type === 'arco-r') {
      const forma = localidad.forma as ArcoRadio;
      
      baseStyles.borderTopLeftRadius = `${forma.radioSuperiorIzquierdo}px`;
      baseStyles.borderTopRightRadius = `${forma.radioSuperiorDerecho}px`;
      baseStyles.borderBottomLeftRadius = `${forma.radioInferiorIzquierdo}px`;
      baseStyles.borderBottomRightRadius = `${forma.radioInferiorDerecho}px`;
    }
  
    return baseStyles;
  }

  getFilaStyles(fila: Fila) {
    const baseStyles: any = {
      gap: `${fila.separacion_entre_asientos}px`,
      height: `${fila.alto_de_asiento}px`,
      marginTop: `${fila.margen_t}px`,
      marginBottom: `${fila.margen_b}px`,
      marginLeft: `${fila.margen_l}px`,
      marginRight: `${fila.margen_r}px`,
      transform: `rotate(${fila.inclinacion}deg) skew(${fila.curvatura}deg)`,
      clear: fila.salto ? 'both' : 'none'
    };

    if (fila.inclinacion !=null && fila.inclinacion !=0) {
      baseStyles.position = 'absolute';
    }

    return baseStyles;
  }

  getTextoFilaStyles(fila:Fila){ 
    return {
      transform: `rotate(${fila.inclinacion*-1}deg)`,
    };
  }

  getAsientoStyles(fila: Fila, ticket: Ticket) {
    return {
      width: `${fila.ancho_de_asiento}px`,
      height: `${fila.alto_de_asiento}px`,
      lineHeight: `${fila.alto_de_asiento}px`,
      backgroundColor:
      // Si el ticket es de tipo 1 (palco) y no hay asientos disponibles
      ticket.tipo === 1 && ticket.asientosDisponibles === 0 
        ? (ticket.estado === 1 || ticket.estado === 2 || ticket.estado === 4 ? 'red' 
          : ticket.estado === 3 ? '#ff7c47' 
          : `${fila.color}`)
        // Si el ticket es de tipo 1 (palco) pero tiene asientos disponibles
        : ticket.tipo === 1 && ticket.asientosDisponibles > 0 
          ? `${fila.color}`
          // Si el ticket es de tipo 0 (normal), manejar según el estado
          : ticket.estado === 1 || ticket.estado === 2  || ticket.estado === 4? 'red' 
          : ticket.estado === 3 
            ? '#ff7c47'
            : `${fila.color}`,
      borderRadius: `${fila.redondeado_de_asiento}px`,
      color: fila.color_de_texto,
      fontSize: `${fila.font_size}px`,
      borderColor: fila.color_de_borde ?? 'transparent',
      borderWidth: '1px',
      borderStyle: 'solid',
      cursor: ticket.estado === 0 ? 'pointer' : 'default'
    };
  }

  
  
  //#endregion
  //----------------------------------------------------------------------
 
  getEstadoTicket(ticket: Ticket): string {
    if (ticket.tipo === 1) {
      // Si el ticket es tipo 1 (palco), validar asientos disponibles
      if (ticket.asientosDisponibles === 0) {
        if (ticket.estado === 1 || ticket.estado ===2 || ticket.estado===4 ) {
          return 'Vendido';
        } else if (ticket.estado === 3) {
          return 'En Proceso de Compra';
        }
      } else {
        return 'Disponible'; // Si tiene asientos disponibles, retornar "Disponible"
      }
    }
  
    // Para tickets de otros tipos o si no hay asientos disponibles, aplicar lógica original
    switch (ticket.estado) {
      case 0: return 'Disponible';
      case 1: return 'Vendido';
      case 2: return 'Vendido';
      case 3: return 'En Proceso de Compra';
      default: return 'Vendido';
    }
  }
  

  zoomIn(): void {
    if (this.zoomFactor < this.maxZoom) {
      this.zoomFactor += 0.3;
    }
    this.getAltoDinamicoMapa()
  }

  zoomOut(): void {
    if (this.zoomFactor > this.minZoom) {
      this.zoomFactor -= 0.3;
    }
    this.getAltoDinamicoMapa()
  }

  seleccionarTicket(ticket: Ticket): void { //VALIDACIONES DEL FRONT AL CREAR ORDEN DE TICKETS INDIVIDUALES

    
    //Validar usuario autenticado
    if (this.autenticador.getUsuario()) {
      //Un ticket cargado en el mapa solamente es clickeable si su estado es Disponible
      //Falta hacer la validacion de palcosdisponibles en el back

    

      if(ticket.tipo ===1 && ticket.asientosDisponibles>0){//Si el ticket es un palco individual se abre para seleccionar la cantidad
        if (this.ticketsSeleccionados.length == 0){

          if(!this.cliente){
            this.autenticar().then(()=>{
              this.seleccionarCantidadPalco(ticket);

            })
          }
          else{
            this.seleccionarCantidadPalco(ticket);
          }

        }
        else{
          this.hideTicketTooltip()
          this.mensaje('En una compra solo puedes seleccionar tickets de la misma localidad');
        }
      }
      else{
        if (ticket.estado === 0) {

            if (this.ticketsSeleccionados.length > 0) { //Si hay algun ticket ya agregado a la orden, se deben hacer las siguientes validaciones

              const index = this.ticketsSeleccionados.findIndex(t => t.id === ticket.id);; //Validar si el ticket ya esta agragado en la orden actual
              
             // Si el ticket ya está agregado a la orden actual, se cambia el estado en el back y se remueve de los tickets seleccionados
              if (index > -1) {
                this.hideTicketTooltip()
                this.mapaService.liberarTicket(ticket.id).subscribe({
                  next: () => {
                    this.ticketsSeleccionados.splice(index, 1);
                    this.calcularTotal()
                  },
                  error: (error) => {
                    
                    console.error("Ocurrio un error, por favor refresca la página", error);
                  }
                });
              }
              else { //si el ticket no esta agregado debemos validar que la localidad del ticket a agregar sea la misma del primer ticket agregado
    
                // Obtener la localidadId del primer ticket seleccionado
                const localidadSeleccionada = this.ticketsSeleccionados[0].localidadId;
    
                //Si la localidad del ticket a agregar coincide con la del primer ticket, procedemos..
                if (ticket.localidadId === localidadSeleccionada) {
                  this.agregarTicketaOrden(ticket);
                } else {
                  this.hideTicketTooltip()
                  // Si la localdad del primer ticket agregado no coincide con la del ticket a agregar, mostrar mensaje
                  this.mensaje('En una compra solo puedes seleccionar tickets de la misma localidad. Puedes realizar varias ordenes despues de finalizar la actual');
                  return
                }
              }
            }
            else{
              this.agregarTicketaOrden(ticket);
            }
          
      }

      }

        
    }
    else {
      this.hideTicketTooltip()
      this.modalLogin()
      this.mensaje("Debes estar registrado en All Tickets para poder realizar tu compra, en caso de no estarlo por favor crea una cuenta nueva")

    }
  }

  agregarTicketaOrden(ticket: Ticket): void { ////VALIDACIONES DEL BACK AL CREAR ORDEN DE TICKETS INDIVIDUALES

    //1. en primer lugar validar en el back que el estado sea disponible
    this.ticketService.getPorId(ticket.id).subscribe({
      next: (ticketBD: Ticket) => {
        
        if(ticketBD.estado!=0){
          this.mensaje("Este ticket ya ha sido seleccionado por otra persona. OK para actualizar el mapa");
          this.cargarMapa()
        }
        //si el ticket no esta seleccionado proceder a cambiar estado de ticket en el back y agregar a ticketsSeleccionados
        else{
          this.mapaService.procesarTicket(ticketBD.id).subscribe({
            next: () =>{
              this.ticketsSeleccionados.push(ticket);
              this.calcularTotal()
            }});
          
        }
      },
      error: (error) => console.error('Error al buscar el ticket:', error)
      });
  }

  calcularTotal(): void {
    this.valorTotal = this.ticketsSeleccionados.reduce((total, ticket) => {
      return total + (this.calcularTotalTicket(ticket));
    }, 0);
    this.cantidadTotal = this.ticketsSeleccionados.reduce((cantidad, ticket) => {
      return cantidad + (ticket.cantidadAsientos);
    }, 0); 
  }

  isSelected(ticket: Ticket): boolean {
    return this.ticketsSeleccionados.includes(ticket);
  }
  //copiar_
  seleccionarCantidadNoNumerada(localidad: LocalidadMapa) {

    this.hideTicketTooltip()

    if (this.autenticador.getUsuario()) {


      if (this.ticketsSeleccionados.length == 0){


        if(!this.cliente){
          this.autenticar().then(()=>{
            this.abrirSeleccionarCantidadNoNumerada(localidad)
          })
        }
        else{
          this.abrirSeleccionarCantidadNoNumerada(localidad)
        }
          
        
      }
      else{
        this.mensaje("En una orden solo puedes comprar una localidad. Remueve los tickets seleccionados")
      }
    }
    else {
      this.modalLogin()
      this.mensaje("Debes estar registrado en All Tickets para poder realizar tu compra, en caso de no estarlo por favor crea una cuenta nueva")

    }
  }


  abrirSeleccionarCantidadNoNumerada(localidad: LocalidadMapa): void{

    if(localidad.localidadesIds.length>1)
      {
        
    //Encontrar localidad a comprar

    //Abrrir modal para seleccionar cantidad
    let screenWidth = screen.width;
    let anchoDialog: string = '600px';
    if (screenWidth <= 600) {
      anchoDialog = '100%';
    }

    const dialogRef = this.dialog.open(LocalidadSeleccionComponent, {
      width: anchoDialog,
      maxWidth: anchoDialog,

      data: {
        localidadesIds: localidad.localidadesIds, //Arreglo de localidades
        localidades: this.localidades, //localidades para el tipo de orden
        cliente: this.cliente,
        eventoId: this.eventoId,
        codigoVenta:this.codigoVenta
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.dialog.closeAll();
    });
      }

      else{

    const localidadId = localidad.localidadesIds[0].id
    //Encontrar localidad a comprar
    this.localidad = this.localidades.find(localidad => localidad.id == localidadId);

    //Abrrir modal para seleccionar cantidad
    let screenWidth = screen.width;
    let anchoDialog: string = '600px';
    if (screenWidth <= 600) {
      anchoDialog = '100%';
    }

    const dialogRef = this.dialog.open(CantidadBoletasComponent, {
      width: anchoDialog,
      maxWidth: anchoDialog,

      data: {
        localidad: this.localidad,
        cliente: this.cliente,
        eventoId: this.eventoId,
        codigoVenta:this.codigoVenta
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if(result){
        this.cargando = true
      }
      else{
        this.cargando= false;

      }
    });

}

  }

  seleccionarCantidadPalco(ticketPadre: Ticket) {
    this.hideTicketTooltip()
        // Abrrir modal para seleccionar cantidad de tickets del palco
        let screenWidth = screen.width;
        let anchoDialog: string = '600px';
        if (screenWidth <= 600) {
          anchoDialog = '100%';
        }

        this.localidad = this.localidades.find(localidad => localidad.id == ticketPadre.localidadId);

  
        const dialogRef = this.dialog.open(CantidadBoletasComponent, {
          width: anchoDialog,
          maxWidth: anchoDialog,
          data: {
            idTicketPadre: ticketPadre.id, // Pasamos el ticket padre
            cliente: this.cliente,
            eventoId: this.eventoId,
            cantidadPalcosDisponibles: ticketPadre.asientosDisponibles, // Opcional, si necesitas este dato
            codigoVenta:this.codigoVenta,
            localidad:this.localidad
          },
        });
  
        dialogRef.afterClosed().subscribe((result) => {
          if(result!=false && result!=undefined){
            this.dialog.closeAll();
            this.cargando=true
          }
 
        });
  
  }
  

  async abrirCarrito() {

    if (this.ticketsSeleccionados.length == 0) {
      this.mensaje('Selecciona los tickets que deseas comprar')
      return
    }

    if (this.autenticador.getUsuario()) {

      this.cargando=true
      if(!this.cliente){
        this.autenticar().then(()=>{
          this.crearOrdenNumerada()
        })
      }
      else{
        this.crearOrdenNumerada()
      }
    }
    else {
      this.hideTicketTooltip()
      this.modalLogin()
      this.mensaje("Debes estar registrado en All Tickets para poder realizar tu compra, en caso de no estarlo por favor crea una cuenta nueva")
    }
  }


  crearOrdenNumerada(): void{

     //Encontrar localidad a comprar
     this.localidad = this.localidades.find(localidad => localidad.id == this.ticketsSeleccionados[0].localidadId);
     let tipo: number = (this.localidad.tipo == 1 || this.localidad.tipo == 3) ? 4 : 1

    if(!this.codigoVenta){
      this.ordenService.crearOrdenClienteCompraNumerados(tipo, this.eventoId, this.cliente.numeroDocumento, this.ticketsSeleccionados).subscribe({
        next: response => {
          if (response.ordenId) {
            this.router.navigate([`/eventos/carrito/${response.ordenId}`])
          }
          else if (response.mensaje) {
            this.cargando=false
            this.mensaje(response.mensaje)
          }
        }, error: error => {
          this.cargando=false
          this.mensaje('Hubo un error al procesar tu solicitud. Por favor, intenta de nuevo.');

        }
      })
    }
    else{
      this.ordenService.crearOrdenClienteCompraNumeradosPromotor(tipo, this.eventoId, this.cliente.numeroDocumento, this.ticketsSeleccionados,this.codigoVenta).subscribe({
        next: response => {
          if (response.ordenId) {
            this.router.navigate([`/eventos/carrito/${response.ordenId}`])
          }
          else if (response.mensaje) {
            this.cargando=false
            this.mensaje(response.mensaje)
          }
        }, error: error => {
          this.cargando = false
          this.mensaje('Hubo un error al procesar tu solicitud. Por favor, intenta de nuevo.');

        }
      })
    }
  }

  getPathArco(arco: Arco): string {
    const startXOuter = 0;
    const startYOuter = (arco.altoArco / 2) ;
  
    const endXOuter = arco.anchoArco ;
    const endYOuter = (arco.altoArco / 2) ;
  
    const startXInner = (startXOuter + arco.grosor );
    const startYInner = (startYOuter + arco.grosor );
  
    const endXInner = (endXOuter - arco.grosor );
    const endYInner = (endYOuter + arco.grosor );
  
    const radiusXInner = (arco.radio_x - arco.grosor) ;
    const radiusYInner = (arco.radio_y - arco.grosor) ;
  
    const radiox = arco.radio_x ;
    const radioy = arco.radio_y ;
  
    return `
      M${startXOuter},${startYOuter}
      A${radiox},${radioy} 0 0 1 ${endXOuter},${endYOuter}
      L${endXInner},${endYInner}
      A${radiusXInner},${radiusYInner} 0 0 0 ${startXInner},${startYInner}
      Z
    `;
  }

  centerX(ancho: number): number {
    return ancho / 2;
  }

 
  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event: BeforeUnloadEvent) {
    if (this.ticketsSeleccionados.length > 0) {
      event.preventDefault();
    }
  }
  @HostListener('window:beforeunload', ['$event'])
  unloadHandler(event: Event) {
    if (this.ticketsSeleccionados.length > 0) {
      this.abrirTickets();
      event.preventDefault();
    }
  }

  abrirTickets() {
    this.mapaService.cambiarEstados(this.ticketsSeleccionados).subscribe({
      next: () => {},
      error: (error) => {
      }
    });
  }
  
  // Manejar navegación hacia atrás/adelante

 
  async autenticar() {
    this.usuario = this.autenticador.getUsuario();
    if (this.usuario) {
      return new Promise((resolve) => {
        this.clienteDataService.getClientePago(this.usuario).subscribe({
          next: response => {
            this.cliente = response.cliente;
            resolve(true);
          },
          error: error => {
            resolve(false); // Aseguramos resolver incluso en caso de error
          }
        });
      });
    } else {
      return Promise.resolve(false); // Retornamos una Promise resuelta si no hay usuario
    }
}

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {

    const offsetX = 0; // Ajusta la distancia horizontal desde el cursor
    const offsetY = 10; // Ajusta la distancia vertical desde el cursor

    // Posicionar el tooltip en el body
    this.renderer.setStyle(this.tooltip, 'top', `${event.pageY - offsetY}px`); // Posición en Y
    this.renderer.setStyle(this.tooltip, 'left', `${event.pageX - offsetX}px`); // Posición en X
  }

  showTooltip(localidad: LocalidadMapa) {
    let content= ``

    if(localidad.localidadesIds.length>1){
      content = `<h4>${localidad.nombre}</h4>
      <p class="hover-nombre">Click para seleccionar localidad</p>
      <div class="divider"></div>
    `;
    }
    else{

      if(localidad.localidadesIds.length>0){
        content = `
        <p class="hover-nombre">${localidad.nombre}</p>
        <h4>COP $${localidad.precio.toLocaleString()}</h4>
         <div class="divider"></div>
        `;
      }

    }

    if(localidad.localidadesIds.length>0){
      this.tooltip.innerHTML = content;
      this.renderer.setStyle(this.tooltip, 'visibility', 'visible');
      this.renderer.setStyle(this.tooltip, 'opacity', '1');
    }

  }

  hideTooltip() {
    this.renderer.setStyle(this.tooltip, 'visibility', 'hidden');
    this.renderer.setStyle(this.tooltip, 'opacity', '0');
  }

  showTicketTooltip(ticket: any){
    if(ticket.tipo ==1 && ticket.asientosDisponibles>0){
      this.mostarHoverTicket(ticket)
    }
    else if(ticket.tipo === 0 && ![1, 2,4].includes(ticket.estado)){
      this.mostarHoverTicket(ticket)
    }
  }

  mostarHoverTicket(ticket: any) {
    this.tooltipVisible = true;
    // Condicional para verificar si ticket.tipo es 1
    let content;
    if (ticket.tipo === 1) {
      content = `
      <h4>COP $${(ticket.precio+ticket.servicio+ticket.servicio_iva).toLocaleString()}</h4>
        <strong>Palco Individual</strong><br />
        ${this.getEstadoTicket(ticket)}<br />
        Disponibles: ${ticket.asientosDisponibles}
      `;
    } else if(ticket.cantidadAsientos<=1) {
      content = `
        <h4>COP $${this.calcularTotalTicket(ticket).toLocaleString()}</h4>
        <h5> <strong>${ticket.numero_dentro_de_evento}</strong></h5>
        ${this.getEstadoTicket(ticket)}<br />
        Personas: ${ticket.cantidadAsientos}
      `;
    }
    else{
      content = `
        <h4>COP $${this.calcularTotalTicket(ticket).toLocaleString()}</h4>
        ${this.getEstadoTicket(ticket)}<br />
        Personas: ${ticket.cantidadAsientos}
      `;
    }
  
  
  // Asumiendo que el tooltip está creado en el DOM
  this.tooltip.innerHTML = content;

  // También aseguramos que el tooltip sea visible
  this.renderer.setStyle(this.tooltip, 'visibility', 'visible');
  this.renderer.setStyle(this.tooltip, 'opacity', '1');
}

hideTicketTooltip() {
  this.tooltipVisible = false;
  this.renderer.setStyle(this.tooltip, 'visibility', 'hidden');
  this.renderer.setStyle(this.tooltip, 'opacity', '0');
}

calcularTotalTicket(ticket: Ticket): number {
  let total = ticket.precio + ticket.servicio + ticket.servicio_iva;
  if (ticket.cantidadAsientos>1) {
 
      total= total*ticket.cantidadAsientos;
    
  }
  return total;
}

//Zoom automático
@HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.anchoPantalla = window.innerWidth;
    this.ajustarZoom()
  }
  ngAfterViewInit() {
    const mapaContainer = document.querySelector('.mapa-container') as HTMLElement;
    
    mapaContainer.addEventListener('mousedown', (e: MouseEvent) => {
      if (!(e.target as HTMLElement).closest('.ticket') && 
          !(e.target as HTMLElement).closest('.localidad')) {
        this.isDragging = true;
        this.startX = e.pageX;
        this.startY = e.pageY;
        this.scrollLeft = mapaContainer.scrollLeft;
        this.scrollTop = mapaContainer.scrollTop;
        mapaContainer.style.cursor = 'grabbing';
      }
    });

    window.addEventListener('mousemove', (e: MouseEvent) => {
      if (!this.isDragging) return;
      e.preventDefault();
      
      const dx = e.pageX - this.startX;
      const dy = e.pageY - this.startY;
      
      mapaContainer.scrollLeft = this.scrollLeft - dx;
      mapaContainer.scrollTop = this.scrollTop - dy;
    });

    window.addEventListener('mouseup', () => {
      this.isDragging = false;
      mapaContainer.style.cursor = 'grab';
    });
  }

  ngOnDestroy() {
    if (this.tooltip && this.tooltip.parentNode) {
      this.tooltip.parentNode.removeChild(this.tooltip);
    }
    window.removeEventListener('mousemove', () => {});
    window.removeEventListener('mouseup', () => {});

  }
}
